import React from 'react'

const LoadingScreenStyle = {
    position: 'fixed',
    top: '0',
    left: '0',
    width: '100vw',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0)',
    zIndex: 9999
}

export default function LoadingScreen() {
    return (
        <div style={LoadingScreenStyle} className="fadeout">
            <div className="spn"></div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/Component/LoadingScreen.js